import { createReducer, on } from '@ngrx/store';
import {
  addCalibrationData,
  addCalibrationDataFailure,
  addCalibrationDataSuccess,
} from '@app/store/Actions/annotation-tool/calibration.actions';


export interface CalibrationState {
  calibrationData: Record<string, number>;
  loading?: boolean;
  error?: string;
}

export const initialCalibrationState: CalibrationState = {
  calibrationData: {},
  loading: true,
};

export const CalibrationReducer = createReducer(
  initialCalibrationState,
  on(addCalibrationData, (state) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(addCalibrationDataSuccess, (state, { gridId, data }) => {
    return {
      ...state,
      calibrationData: {
        ...state.calibrationData,
        [gridId]: data,
      },
      loading: false,
    };
  }),
  on(addCalibrationDataFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error.message,
  })),
);
